import { connect, Dispatch } from 'react-redux';
import { previewImages } from '../../actions';
import { Store } from '../../store';
import { PhotoUploader, PhotoUploaderActions, PhotoUploaderAttributes } from './photoUploader';

function mapStoreToAttributes(store: Store): PhotoUploaderAttributes {
  return {
    imageDataUrls: store.imagePreviews,
    photoFiles: []
  };
}

function mapDispatchToActions(dispatch: Dispatch<Store>): PhotoUploaderActions {
  return {
      previewFiles: files => {
          dispatch(previewImages(files));
      }
  };
}

export default connect(mapStoreToAttributes, mapDispatchToActions)(PhotoUploader);
